module.exports = __webpack_public_path__ + "img/ntp.302b6ee4.png";